import { gql, useMutation } from "@apollo/client";
import "jspdf-autotable";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import PortalFooter from "../../../Components/Reactportal/PortalFooter";
import Reactportal from "../../../Components/Reactportal/Reactportal";
import { Confirm } from "../../Confirmation/Confirm";
import DownloadExcelSheet from "../../DownloadExelSheet/DownloadExelSheet";
import Input from "../../Input/Input";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import { Data } from "../AddJournalVoucher/AddJournalVoucher.config";
import useKeyDown from "../AddLoad/text";
import "./AddPaymentProcess.scss";
import AddPaymentProcessSection from "./AddPaymentProcessSection/AddPaymentProcessSection";

const PaymentProcess = gql`
  mutation EditPaymentRequests_TO_PaymentProcessed(
    $editPaymentRequestsToPaymentProcessedPaymentprocessinput2: Paymentprocessinput
  ) {
    editPaymentRequests_TO_PaymentProcessed(
      Paymentprocessinput: $editPaymentRequestsToPaymentProcessedPaymentprocessinput2
    ) {
      _id
      Date
      Unique_Id
      Party_Name
      Account_Type
      Reference_No
      Bank_Name
      Bank_IFSC_Code
      Account_Number
      Amount
      Remarks
      Narration
      Status
      TypeOfPayment
      Debit_Account_Number
      Debit_Account_IFSC_Code
      createdAt
      updatedAt
    }
  }
`;

const AddPaymentProcess = ({ show, id, TypeOfPortal, submitType, ParentPortalCloseFunction }) => {
  const [processPayment] = useMutation(PaymentProcess);
  const Tab = useSelector((store) => store.SelectedTabData.tab);
  const fielddataRedux = useSelector((store) => store.UniqueTableReducer);
  const fielddata = fielddataRedux[Tab]?.Selected_Row;
  const [IFSCCode, setIfsc] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [toggle, settoggle] = useState(show ? show : false);
  const [alldata, setalldata] = useState({});
  // eslint-disable-next-line
  const [allFieldsData, setAllFieldsData] = useState({});
  const [AccountName, setAccount_Name] = useState("");
  const FormData = useSelector((store) => store.FormFieldData);
  const MasterData = useSelector((store) => store?.FormFieldData?.masterData);
  const [selectedRows, setSelectedRows] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    let BankData = MasterData?.Bank_Name;
    if (BankData) {
      setIfsc(BankData?.AccountData?.IFSC_Code);
    }
  }, [MasterData]);

  useEffect(() => {
    if (AccountName) {
      let updatedPayments = selectedRows.map((el, i) => {
        if (IFSCCode?.slice(0, 4) === el?.Bank_IFSC_Code?.slice(0, 4)) {
          return { ...el, TypeOfPayment: "IFT" };
        }
        return el;
      });
      setSelectedRows(updatedPayments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [AccountName, IFSCCode]);
  useEffect(() => {
    if (transactionType) {
      let updatedPayments = selectedRows.map((el, i) => {
        if (el.Bank_IFSC_Code !== IFSCCode && el.TypeOfPayment1 !== "IFT") {
          return { ...el, TypeOfPayment: transactionType };
        }
        return el;
      });
      setSelectedRows(updatedPayments);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transactionType]);
  const handleTablePaymentChange = (data) => {
    setSelectedRows(data);
  };

  useEffect(() => {
    setalldata(FormData.fielddata);
  }, [FormData]);

  useEffect(() => {
    if (fielddataRedux[Tab]?.Selected_Rows?.length) {
      setSelectedRows(fielddataRedux[Tab]?.Selected_Rows);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fielddataRedux]);

  useEffect(() => {
    if (show === true) {
      settoggle(true);
    }
  }, [show]);
  const submit = async () => {
    //exportPdf()
    // debugger;
    let data = {};
    if (alldata.Doc_Details) {
      for (let key in alldata) {
        data = {
          ...data,
          ...alldata[key],
        };
      }
    }
    if (TypeOfPortal === "Payment Process") {
      let updatedRequest = selectedRows.map((el) => {
        let obj = { ...el };
        if (obj.createdAt) {
          delete obj.createdAt;
        }
        if (obj.updatedAt) {
          delete obj.updatedAt;
        }
        if (obj.__typename) {
          delete obj.__typename;
        }
        return obj;
      });

      await processPayment({
        variables: {
          editPaymentRequestsToPaymentProcessedPaymentprocessinput2: {
            From_BankBalance_Account_ID: MasterData?.Bank_Name?._id,
            requests: updatedRequest,
          },
        },
      })
        .then((res) => {
          DownloadExcelSheet(res.data.editPaymentRequests_TO_PaymentProcessed);
          SuccessToast("process completed");
          dispatch({ type: "Refetch", payload: true });
          Closeformfunction();
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
  };
  // eslint-disable-next-line
  const Closeformfunction = () => {
    ParentPortalCloseFunction();
    settoggle(false);
    dispatch({ type: "ClearData", payload: { data: {} } });

    setAccount_Name("");
    setTransactionType("");
  };


  if (TypeOfPortal === "Delete Journal Voucher" || TypeOfPortal === "Delete") {
    return (
      <>
        <Confirm toggle={toggle} settoggle={settoggle} submit={submit} loadingState={false} />
      </>
    );
  }

  return (
    <div>
      {" "}
      <div
        style={{
          display: id ? "none" : "block",
        }}
        onClick={() => {
          settoggle(!toggle);
        }}
      ></div>
      <Reactportal
        open={toggle}
        onClose={Closeformfunction}
        TypeOfPortal={TypeOfPortal}
        id={allFieldsData && allFieldsData.Unique_Id ? allFieldsData.Unique_Id : id}
      >
        <div className="paymentProcessContainer1">
          <div className="AccountName_TransactionType">
            <Input
              EMTQuery=""
              checked={""}
              InputConfig=""
              value={AccountName || ""}
              name="Bank_Name"
              modalform={true}
              Iconinside={true}
              type="InputDropForQuery"
              handleInputChange={(e) => {
                setAccount_Name(e.target.value);
              }}
          
              handleBlur={() => {}}
              transactions={true}
            />
            <Input
              EMTQuery=""
              checked={""}
              InputConfig=""
              value={transactionType}
              name="Transaction_Type"
              modalform={true}
              Iconinside={true}
              type="inputdrop"
              handleInputChange={(e) => {
                setTransactionType(e.target.value);
              }}
              dropdowndata={["IFT", "NEFT", "IMPS", "RTGS"]}
              handleBlur={() => {}}
              transactions={true}
            />
          </div>
          {Data?.map((e) => {
            return (
              <>
                <AddPaymentProcessSection
                  inputfields={e.fields}
                  Type={e.name}
                  fielddata={allFieldsData}
                  name={e.name}
                  selectedRows={selectedRows}
                  handleTablePaymentChange={handleTablePaymentChange}
                />
              </>
            );
          })}
        </div>

        <PortalFooter
          renderContent={() => <></>}
          disabled={false}
          submitform={submit}
          submitType={submitType}
          SaveAndClose={() => {
            Closeformfunction();
            submit("close");
          }}
          handleformclose={() => {
            Closeformfunction();
            settoggle(!toggle);
          }}
          loadingState={false}
        />
      </Reactportal>
    </div>
  );
};

export default AddPaymentProcess;
